import type { TOC } from '@ember/component/template-only';

interface GeneralFilterBarDividerSignature {
  Args: {};
}

const GeneralFilterBarDivider = <template>
  <svg
    aria-hidden="true"
    fill="none"
    height="32"
    viewBox="0 0 2 32"
    width="2"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0V32"
      stroke="var(--prism-color-border-neutral-default)"
      stroke-width="2"
    />
  </svg>
</template> satisfies TOC<GeneralFilterBarDividerSignature>;

export default GeneralFilterBarDivider;
